import React from 'react';
import moment from 'moment';
import t from 'react-translate';

import { Poll } from 'redux/schemas/models/poll';

import NvIcon from 'shared/components/nv-icon';
import { CheckIcon, todoIcon, todoProgress } from './todo-row';
import TodoThumbnail, { TodoThumbnailProps } from './todo-thumbnail';
import ActivityDeadline from './activity-deadline';

type PollTodoProps = Poll & TodoThumbnailProps;

function PollTodo({
  type,
  title,
  progress,
  expirationDate,
  thumbnailSrc,
  backgroundColor,
}: PollTodoProps) {
  const deadlineMoment = moment(expirationDate);
  const currentMoment = moment();

  const isMissed = progress === todoProgress.MISSED;
  const isComplete = progress === todoProgress.COMPLETED;
  const isNotStarted = progress === todoProgress.NOT_STARTED;

  const showDueSoon = expirationDate
    && !isComplete
    && !isMissed
    && deadlineMoment > currentMoment
    && deadlineMoment < moment().add(7, 'days');

  const todoClassNames = [
    'todo-container',
    isComplete && 'completed',
    showDueSoon && 'due-soon',
  ]
    .filter(Boolean)
    .join(' ');

  const icon = <NvIcon icon={todoIcon[type]} size='smallest' />;
  const showTodoIcon = isNotStarted || isMissed;
  const showCheckIcon = isComplete;

  return (
    <div className={todoClassNames}>
      <div className='todo-description'>
        <TodoThumbnail
          thumbnailSrc={thumbnailSrc}
          backgroundColor={backgroundColor}
        />
        <div className='todo-icon'>
          {showTodoIcon && icon}
          {showCheckIcon && <CheckIcon />}
        </div>
        <div className='todo-title'>
          {title}
        </div>
      </div>
      <div className='todo-content'>
        <div className='status'>
          {isComplete && t.TIMELINE.EXERCISE_STATUS.SUBMITTED()}
          {isMissed && t.TIMELINE.EXERCISE_STATUS.MISSED()}
        </div>
        <ActivityDeadline deadline={expirationDate} />
      </div>
    </div>
  );
}

export default PollTodo;
